import React from "react";
import DomainAddOutlinedIcon from "@mui/icons-material/DomainAddOutlined";
const AddHouse = () => {
  return <DomainAddOutlinedIcon sx={{ color: "white" }} />;
};

export default AddHouse;
